import axios from 'axios'

export async function loadMicroManifest (baseUrl) {
  const { data } = await axios.create().get(`${baseUrl}manifest.json`, { withCredentials: false })
  return data
}

export async function loadMicroApp (manifest) {
  const { scope } = manifest
  const modules = manifest.modules || {}
  if (manifest.module) modules.module = manifest.module
  // Initializes the share scope. This fills it with known provided modules from this build and all remotes
  /* eslint-disable */
  await __webpack_init_sharing__('default')

  const container = window[scope] // or get the container somewhere else
  // Initialize the container, it may provide shared modules
  await container.init(__webpack_share_scopes__.default)
  
  const createdModules = {}
  for (const module of modules) {
    const moduleName = module.split('/').pop()
    const factory = await window[scope].get(module)
    const Module = factory()
    createdModules[module] = window[moduleName] = Module
  }
  return createdModules
}

export async function loadMicroScript (src) {
  return new Promise((resolve, reject) => {
    const element = Object.assign(document.createElement('script'), {
      type: 'text/javascript',
      async: true,
      src,
      onload: resolve,
      onerror: reject
    })
    document.head.appendChild(element)
  })
}
